import { insertTable as insertTable_1 } from 'owa-locstrings/lib/strings/inserttable.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { RibbonButton, RibbonDropDownProps } from './RibbonButton';

import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { insertTable as insertTableCmd } from 'roosterjs-editor-api';
import { InsertTablePane } from 'owa-editor-insert-table-pane';

const MAX_TABLE_WIDTH = 10;
const MAX_TABLE_HEIGHT = 10;

const insertTable: RibbonButton = {
    key: 'insertTable',
    title: () => loc(insertTable_1),
    imageSrc: require('../svg/table.svg'),
    createDropDownCallback: React.memo(({ target, plugin, dismiss }: RibbonDropDownProps) => {
        const onInsertTable = React.useCallback(
            (cols, rows) => insertTableCmd(plugin.getEditor(), cols, rows),
            [plugin]
        );
        return (
            <Callout
                gapSpace={0}
                target={target}
                isBeakVisible={false}
                directionalHint={DirectionalHint.bottomAutoEdge}
                onDismiss={dismiss}>
                <InsertTablePane
                    editor={plugin.getEditor()}
                    onInsertTable={onInsertTable}
                    maxNumCols={MAX_TABLE_HEIGHT}
                    maxNumRows={MAX_TABLE_WIDTH}
                />
            </Callout>
        );
    }),
};

export default insertTable;
